import {
  call, put, takeLatest, all, select,
} from 'redux-saga/effects';

import v4 from 'uuid/v4';
import { authRequest } from '../../helpers/request.helper';

import {
  DRIVE_EDIT_DOCUMENT_ATRIBUTES_FAILURE,
  DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST,
  DRIVE_EDIT_DOCUMENT_ATRIBUTES_SUCCESS,
  DRIVE_FETCH_CURRENT_DIRECTORY_FAILURE,
  DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST,
  DRIVE_REMOVE_DOCUMENTS_FAILURE,
  DRIVE_REMOVE_DOCUMENTS_REQUEST,
  DRIVE_REMOVE_DOCUMENTS_SUCCESS, DRIVE_SET_ENTIDADES_FAILURE, DRIVE_SET_ENTIDADES_REQUEST, DRIVE_SET_ENTIDADES_SUCCESS,
  DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_FAILURE,
  DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST,
  DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_SUCCESS,
} from '../actions/constants/drive.contants';

import {
  setFilesToCurrentDirectory,
  addFileToCurrentDirectory,
  reemplazarDocumento,
  fetchCurrentDirectory,
  eliminarDocumentoFromStoreById,
  establecerPorcentajeUsoCarpetaActual, 
  establecerEntidades,
  establecerTotalContratado,
} from '../actions/creators/drive.actioncreator';
import { toastDanger } from '../actions/creators/mensajesSistema.actioncreator';

const getDriveState = state => state.drive;

function* driveRequestCurrentDirectory() {
  try {
    const formData = new FormData();
    const { currentDirectory } = yield select(getDriveState);
    const { tipoEntidad: { id: entidadTipoId }, entidadId, tiendaId } = currentDirectory;

    let consulta = {
      entidadTipoId: {
        valor: entidadTipoId,
      },
      entidadId: {
        valor: entidadId,
      },
    };
    const orden = {
      id: 'DESC',
    };

    if (tiendaId) {
      consulta = {
        ...consulta,
        tiendaId: {
          valor: tiendaId,
        },
      };
    }

    formData.append('consulta', JSON.stringify(consulta));
    formData.append('limite', 50);
    formData.append('orden', JSON.stringify(orden));

    const params = {
      url: 'api/awsficheros/buscar',
      method: 'POST',
      body: formData,
    };

    const {
      datos: files, total, porcentajeTotalUso, espacioContratadoEnGB,
    } = yield call(authRequest, params);

    yield put(setFilesToCurrentDirectory({ files, total }));
    yield put(establecerPorcentajeUsoCarpetaActual({ porcentaje: porcentajeTotalUso }));
    yield put(establecerTotalContratado({ total: espacioContratadoEnGB }));
    
  } catch (error) {
    yield put({ type: DRIVE_FETCH_CURRENT_DIRECTORY_FAILURE });
    yield put(toastDanger({ httpError: error }));
  }
}

function* driveUploadRequest({ payload: { file, name, descripcion } }) {
  const generatedId = v4();
  const { currentDirectory: { tiendaId } } = yield select(getDriveState);
  const formData = new FormData();
  formData.append('fichero', file);
  formData.append('nombre', name);
  formData.append('descripcion', descripcion);
  if (tiendaId !== null && tiendaId !== undefined) formData.append('tienda_id', tiendaId);

  const { name: fileName } = file;
  const fileToAdd = {
    id: generatedId,
    nombre: fileName,
  };

  try {
    const { currentDirectory: { tipoEntidad: { id: entidadTipoId }, entidadId } } = yield select(getDriveState);

    yield put(addFileToCurrentDirectory({
      file: {
        ...fileToAdd,
        requestState: 'uploading',
        updating: true,
      },
    }));

    const params = {
      url: `api/aws/s3/tipo/${entidadTipoId}/id/${entidadId}/subir`,
      method: 'POST',
      body: formData,
    };

    const responseFile = yield call(authRequest, params);

    yield put(reemplazarDocumento({
      documento: {
        ...responseFile,
      },
      id: generatedId,
    }));
    yield put({ type: DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_SUCCESS });
  } catch (error) {
    yield put(eliminarDocumentoFromStoreById({ id: generatedId }));
    yield put({ type: DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_FAILURE });
    yield put(toastDanger({ httpError: error }));
  }
}

function* driveEditDocumentById({ payload: { id, nombre, descripcion } }) {
  try {
    const { currentDirectory: { files } } = yield select(getDriveState);

    const documentoAEditar = files.find(file => file.id === id);
    documentoAEditar.updating = true;
    documentoAEditar.requestState = 'updating';
    yield put(reemplazarDocumento({ documento: documentoAEditar }));

    const formData = new FormData();
    formData.append('nombre', nombre);

    if (descripcion !== null) {
      formData.append('descripcion', descripcion);
    }

    const params = {
      url: `api/aws/s3/documento/${id}/editar`,
      method: 'POST',
      body: formData,
    };

    const response = yield call(authRequest, params);
    response.updating = false;

    yield put(reemplazarDocumento({ documento: response }));
    yield put({ type: DRIVE_EDIT_DOCUMENT_ATRIBUTES_SUCCESS });
  } catch (error) {
    yield put({ type: DRIVE_EDIT_DOCUMENT_ATRIBUTES_FAILURE });
    yield put(toastDanger({ httpError: error }));
  }
}

function* driveRemoveDocuments({ payload: { documentos } }) {
  try {
    const documentosIds = documentos.map(documento => documento.id);

    for (let i = 0; i < documentos.length; i++) {
      const documento = documentos[i];

      yield put(reemplazarDocumento({
        documento: {
          ...documento,
          updating: true,
          requestState: 'deleting',
        },
      }));
    }

    const formData = new FormData();
    formData.append('ficherosIds', JSON.stringify(documentosIds));

    const params = {
      url: 'api/aws/s3/eliminar',
      method: 'POST',
      body: formData,
    };

    const files = yield call(authRequest, params);
    yield put({ type: DRIVE_REMOVE_DOCUMENTS_SUCCESS, payload: { files } });
    yield put(fetchCurrentDirectory());
  } catch (error) {
    yield put({ type: DRIVE_REMOVE_DOCUMENTS_FAILURE });
    yield put(toastDanger({ httpError: error }));
  }
}

function* driveEntidadesRequest() {
  try {
    const params = {
      url: 'api/udeipe.entidades/buscar',
      method: 'POST',
    };
    const { datos } = yield call(authRequest, params);
    yield put(establecerEntidades({ entidades: datos }));
    yield put({ type: DRIVE_SET_ENTIDADES_SUCCESS });
  } catch (error) {
    yield put({ type: DRIVE_SET_ENTIDADES_FAILURE });
    yield put(toastDanger({ httpError: error }));
  }
}

function* driveSaga() {
  yield all([
    takeLatest(DRIVE_FETCH_CURRENT_DIRECTORY_REQUEST, driveRequestCurrentDirectory),
    takeLatest(DRIVE_UPLOAD_TO_CURRENT_DIRECTORY_REQUEST, driveUploadRequest),
    takeLatest(DRIVE_EDIT_DOCUMENT_ATRIBUTES_REQUEST, driveEditDocumentById),
    takeLatest(DRIVE_REMOVE_DOCUMENTS_REQUEST, driveRemoveDocuments),
    takeLatest(DRIVE_SET_ENTIDADES_REQUEST, driveEntidadesRequest),
  ]);
}

export default driveSaga;
